import { Typography } from '@mui/material';
import { capitalize } from 'lodash';
import React from 'react';
import {
	InteractionType,
	ITaskInteraction,
	NextActionTaskType
} from 'types/flows';

// eslint-disable-next-line react/require-default-props
type Props = { interaction: ITaskInteraction; label?: string };

export default ({ interaction: action, label }: Props) => {
	let str: string | null = null;
	switch (action.type) {
		case NextActionTaskType.error:
			str = label || intl.tr('flows.action.error');
			break;
		case NextActionTaskType.success:
			str = label || intl.tr('flows.action.success');
			break;
		default: {
			switch (action.icon) {
				case InteractionType.biomertrics:
					str = intl.tr('screenEditor.leftBar.components.buttons.biometrics');
					break;
				case InteractionType.sso:
					str = action.icon.toUpperCase();
					break;
				default:
					str = label || capitalize(action.icon || action.type);
					break;
			}
			break;
		}
	}

	return (
		<Typography
			title={label}
			variant="body2"
			sx={{
				color: 'primary',
				textOverflow: 'ellipsis',
				overflow: 'hidden'
			}}
		>
			{str}
		</Typography>
	);
};
